import { blue } from '@mui/material/colors';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import Switch from '@mui/material/Switch';
import { Set } from 'immutable';
import React from 'react';
import { withTranslation } from 'react-i18next';

const linkStyle = {
  fontSize: '14px',
  color: blue[500],
  marginTop: '10px',
  cursor: 'pointer',
};
const nonClickLinkStyle = { fontSize: '14px', color: 'var(--text-secondary)', marginTop: '10px' };

class NonStaffAuthGroupSelectionComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      subRolesOpen: !props.addonAuthGroups.isEmpty(),
    };
  }

  openSubRoles = () => this.setState({ subRolesOpen: true });

  closeSubRoles = () => this.setState({ subRolesOpen: false });

  addSubRole = id => {
    const { setAddonAuthGroups, addonAuthGroups } = this.props;
    setAddonAuthGroups(addonAuthGroups.add(id));
  };

  removeSubRole = id => {
    const { setAddonAuthGroups, addonAuthGroups } = this.props;
    setAddonAuthGroups(addonAuthGroups.delete(id));
  };

  toggleSubRole = id => {
    const { addonAuthGroups } = this.props;
    addonAuthGroups.has(id) ? this.removeSubRole(id) : this.addSubRole(id);
  };

  basicAuthGroupSwitch = group => {
    const { isBillboard, t } = this.props;
    switch (group) {
      case 7:
        return t('userSettings.administratorDescription');
      case 8:
        return t('userSettings.managerDescription', {
          entityType: t('siteGroups.siteGroup'),
        });
      case 9:
        return t('userSettings.userDescription', {
          entityType: t('sites.site'),
          groupType: t('siteGroups.siteGroup'),
        });
      case 1054:
        return t('userSettings.viewOnlyUserDescription');
      case 1061:
        return t('userSettings.resellerDescription');
      case 1063:
        return t('userSettings.thirdPartyAdminDescription');
      default:
        return t('userSettings.selectRolePrompt');
    }
  };

  changeMainAuthGroup = event => {
    const { setMainAuthGroup, setAddonAuthGroups, mainAuthGroup } = this.props;

    if (event.target.value !== mainAuthGroup) {
      setMainAuthGroup(event.target.value);
      setAddonAuthGroups(Set());
    }
  };

  render() {
    const {
      mainAuthGroup,
      addonAuthGroups,
      canCreateAdmins,
      canCreateManagers,
      canCreateResellers,
      isBillboard,
      canEdit,
      onMobile,
      t,
    } = this.props;

    const { subRolesOpen } = this.state;

    return (
      <div>
        <div style={{}}>
          <Select
            label={t('general.role')}
            hiddenLabel
            value={mainAuthGroup || ''}
            disabled={!canEdit}
            onChange={this.changeMainAuthGroup}
            errorText={mainAuthGroup === '' || !mainAuthGroup ? t('userSettings.mustChooseARole') : ''}
            fullWidth={onMobile}
          >
            <MenuItem value={''} />
            {canCreateResellers && <MenuItem value={1061}>{t('userSettings.reseller')}</MenuItem>}
            {canCreateAdmins && <MenuItem value={7}>{t('userSettings.administrator')}</MenuItem>}
            {canCreateManagers && (
              <MenuItem value={8}>{`${
                isBillboard ? t('siteGroups.plantManager') : t('siteGroups.siteGroupManager')
              }`}</MenuItem>
            )}
            <MenuItem value={9}>{t('userSettings.user')}</MenuItem>
            <MenuItem value={1054}>{t('userSettings.viewOnlyUser')}</MenuItem>
            <MenuItem value={1063}>{t('userSettings.thirdPartyAdmin')}</MenuItem>
          </Select>
        </div>

        <div>{this.basicAuthGroupSwitch(mainAuthGroup)}</div>

        {subRolesOpen && mainAuthGroup === 1054 && (
          <div style={{ marginTop: '16px' }}>
            <h4 style={{ fontSize: '18px' }}>{t('users.assignedSubRoles', 'Assigned Sub Roles')}</h4>
            <div style={{ display: 'flex' }}>
              <Switch
                onChange={() => this.toggleSubRole(10)}
                checked={addonAuthGroups.has(10)}
                label={'Schedule Control'}
                labelPosition="right"
                style={{ width: 'auto', flex: '0 0 220px' }}
              />
              <div style={{ paddingLeft: '16px', color: 'var(--text-secondary)' }}>
                {t(
                  'users.subRoleScheduleHelp',
                  'Allows this user to edit lighting and image schedules (if available).',
                )}
              </div>
            </div>
            <div style={{ display: 'flex' }}>
              <Switch
                onChange={() => this.toggleSubRole(1059)}
                checked={addonAuthGroups.has(1059)}
                label={'Relay Commands'}
                labelPosition="right"
                style={{ width: 'auto', flex: '0 0 220px' }}
              />
              <div style={{ paddingLeft: '16px', color: 'var(--text-secondary)' }}>
                Allows this user to issue relay power commands, such as "On", "Off" and "Reboot".
              </div>
            </div>
            <div style={{ display: 'flex' }}>
              <Switch
                onChange={() => this.toggleSubRole(1060)}
                checked={addonAuthGroups.has(1060)}
                label={'Intrusion Commands'}
                labelPosition="right"
                style={{ width: 'auto', flex: '0 0 220px' }}
              />
              <div style={{ paddingLeft: '16px', color: 'var(--text-secondary)' }}>
                Allows this user to issue Intrusion Sensor Commands, such as "Arm sensor" and "Disarm sensor".
              </div>
            </div>
          </div>
        )}

        {!subRolesOpen && mainAuthGroup === 1054 && (
          <div
            style={linkStyle}
            onClick={this.openSubRoles}
            onKeyDown={e => e.key === 'Enter' && this.openSubRoles()}
            role="button"
            tabIndex={0}
          >
            <i className="fa fa-plus" /> Add sub-roles
          </div>
        )}
        {subRolesOpen && mainAuthGroup === 1054 && (
          <div
            style={addonAuthGroups.isEmpty() ? linkStyle : nonClickLinkStyle}
            onClick={addonAuthGroups.isEmpty() ? this.closeSubRoles : null}
            onKeyDown={e => (e.key === 'Enter' && addonAuthGroups.isEmpty() ? this.closeSubRoles() : null)}
            role="button"
            tabIndex={0}
          >
            <i className="fa fa-minus" /> hide sub-roles
          </div>
        )}
      </div>
    );
  }
}

NonStaffAuthGroupSelectionComponent.defaultProps = {
  canEdit: true,
};

export default withTranslation()(NonStaffAuthGroupSelectionComponent);
